<template>
  <div class="contentBlock">
    <el-container>
      <el-header>
        <div class="search">
          <div class="form">
            <el-form
              :inline="true"
              :model="formInline"
              class="demo-form-inline"
            >
              <el-form-item label="通知内容:">
                <el-input
                  v-model="formInline.content"
                  clearable
                  placeholder="请输入关键字筛选并选择"
                ></el-input>
              </el-form-item>

              <el-form-item label="处理人：">
                <el-select v-model="formInline.operator" style="width: 100px">
                  <el-option label="张三" value="1"></el-option>
                  <el-option label="李四" value="2"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="发送时间:">
                <el-date-picker
                  v-model="formInline.checkedTime"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="getDate(formInline.checkedTime)"
                  clearable
                >
                </el-date-picker>
              </el-form-item>

              <el-form-item label="处理完成时间:">
                <el-date-picker
                  v-model="formInline.finishTime"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="getDate(formInline.finishTime)"
                  clearable
                >
                </el-date-picker>
              </el-form-item>

              <el-form-item label="处理状态：">
                <el-select v-model="formInline.dealStatus" style="width: 100px">
                  <el-option
                    v-for="statusObj in dealStatusArr"
                    :key="statusObj.value"
                    :label="statusObj.label"
                    :value="statusObj.value"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" size="small" @click="search"
                  >搜索</el-button
                >
                <el-button type="primary" size="small" @click="reset"
                  >重置</el-button
                >
                
                <router-link to="/announcement/newOrEdit">
                  <el-button type="primary" size="small">新建通知</el-button>
                </router-link>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-header>
      <el-main class="main">
        <div class="bodyContent">
          <!-- 表格部分 -->
          <div class="table">
            <div class="table_in" style="max-width: 1700px">
              <el-table :data="tableData" stripe max-height="600px">
                <el-table-column
                  prop="index"
                  label="序号"
                  align="center"
                  width="50px"
                >
                  <template slot-scope="scope">
                    <span v-text="getIndex(scope.$index)"> </span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="informContent"
                  label="通知内容"
                  align="center"
                  min-width="200px"
                >
                  <template slot-scope="scope"> {{scope.row.informContent}} </template>
                </el-table-column>
                <el-table-column
                  prop="img"
                  label="图片描述"
                  align="center"
                  min-width="100px"
                >
                  <template slot-scope="scope"> {{scope.row.img}} </template>
                </el-table-column>
                <el-table-column
                  prop="sendTime"
                  align="center"
                  label="发送时间"
                  min-width="200"
                >
                  <template slot-scope="scope">
                    {{
                      scope.row.sendTime
                        ? changeDate(scope.row.sendTime)
                        : "时间未知"
                    }}
                  </template>
                </el-table-column>

                <el-table-column
                  prop="operator"
                  label="处理人"
                  align="center"
                  min-width="100px"
                >
                </el-table-column>
                
                <el-table-column
                  prop="operatorTime"
                  align="center"
                  label="处理完成时间"
                  min-width="200"
                >
                  <template slot-scope="scope">
                    {{
                      scope.row.operatorTime
                        ? changeDate(scope.row.operatorTime)
                        : "时间未知"
                    }}
                  </template>
                </el-table-column>

                <el-table-column
                  prop="dealStatus"
                  label="处理状态"
                  align="center"
                  min-width="200px"
                >
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.dealStatus" style="width: 100px">
                  <el-option label="待处理" value="1"></el-option>
                  <el-option label="处理中" value="2"></el-option>
                  <el-option label="处理完成" value="3"></el-option>
                  <el-option label="已取消" value="4"></el-option>
                </el-select>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="action"
                  label="操作"
                  align="center"
                  min-width="200px"
                >
                  <template>
                    <!-- <router-link :to="{path:'/announcement/newOrEdit',query:{name:scope.row.id}}"> -->
                    <router-link :to="{path:'/announcement/newOrEdit',query:{name:4}}">
                    <el-link :underline="false">查看详情</el-link>
                    </router-link>
                  </template>
                </el-table-column>

              </el-table>
            </div>

            <div class="pagination">
              <el-pagination
                :page-sizes="paginations.page_sizes"
                :page-size="paginations.page_size"
                :layout="paginations.layout"
                :total="paginations.total"
                :current-page="paginations.page_index"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import * as mUtils from "utils/mUtils";

export default {
  data() {
    return {
      // 表单
      formInline: {
        content: "",
        operator: "",
        dealStatus: "",
        checkedTime: "",
        finishTime: "",
      },

      // 人员数组
      peopleArr: [],

      // 选择的时间对应的起始时间戳
      startTime: "",
      endTime: "",

      tableData: [
        {
          informContent: "开会",
          img: "pic1.jpg",
          sendTime: 1648518756000,
          operator: "mike",
          operatorTime: 1648518796000,
          dealStatus: "1",
        },
        {
          informContent: "开会",
          img: "pic2.jpg",
          sendTime: 1648518756000,
          operator: "吴亦凡",
          operatorTime: 1648518796000,
          dealStatus: "4",
        },
        {
          informContent:
            "元旦放假，各部门注意交接。元旦放假，各部门注意交接。元旦放假，各部门注意交接。",
          img: "pic3.jpg",
          sendTime: 1248518756000,
          operator: "John",
          operatorTime: 164345796000,
          dealStatus: "3",
        },
      ],
      // 流水分页
      paginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 10, // 1页显示多少条
        page_sizes: [5, 10, 20, 100], //每页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },

      deliveryList: [], // 派送点列表

      loading: false,

      rowSelection: [],
      howManyTotal: 0,
      listArr: [],
      dealStatusArr: [
        { value: 0, label: "全部" },
        { value: 1, label: "待处理" },
        { value: 2, label: "处理中" },
        { value: 3, label: "处理完成" },
        { value: 4, label: "已取消" },
      ],
    };
  },
  created() {
    
  },
  methods: {
    search() {},
    reset(){
      this.formInline = {
        content: "",
        operator: "",
        dealStatus: "",
        checkedTime: "",
        finishTime: "",
      };
    },

    getIndex($index) {
      //表格序号
      return (
        (this.paginations.page_index - 1) * this.paginations.page_size +
        $index +
        1
      );
    },

    // 将选择的时间转换为时间戳
    getDate(time) {
      if (time) {
        this.startTime = new Date(mUtils.formatDate(time[0])).getTime();
        this.endTime = new Date(mUtils.formatDate(time[1])).getTime();
      } else {
        this.startTime = "";
        this.endTime = "";
      }
    },

    // 获得流水列表
    getBalanceList() {
      let param = {
        pageIndex: this.paginations.page_index,
        pageSize: this.paginations.page_size,
      };
      statisticalApi.getUserBalance(param).then((res) => {
        this.paginations.total = res.data.data.pageCount
          ? res.data.data.pageCount
          : 0;
        if (res.status !== 200) return this.$message.error(res.msg);
        else if (res.data.code !== 0) return this.$message.error(res.data.msg);
        this.tableData = res.data.data.list;
      });
    },

    // 日期转换
    changeDate(row) {
      return mUtils.formatDate(new Date(row), 4);
    },

    // 每页多少条切换
    handleSizeChange(page_size) {
      let that = this;
      that.paginations.page_size = page_size;
      that.getBalanceList();
    },
    // 上下分页
    handleCurrentChange(page) {
      let that = this;
      that.paginations.page_index = page;
      that.getBalanceList();
    },

    //表格序号
    getIndex($index) {
      //表格序号
      return (
        (this.paginations.page_index - 1) * this.paginations.page_size +
        $index +
        1
      );
    },
  },
};
</script>
<style  lang="less" scoped>
.contentBlock {
  width: 100%;
  min-height: 100%;
  margin: 20px 50px 50px 30px;
  & .search {
    width: 100%;
    & #title {
      font-family: "PingFangSC-Semibold", "PingFang SC Semibold", "PingFang SC",
        sans-serif;
      font-weight: 650;
      font-size: 18px;
    }
    & .form {
      margin-top: 20px;
      .search-icon {
        position: absolute;
        right: -56px;
        top: 0px;
      }
    }
  }
  .main {
    margin-top: 50px;
    box-sizing: border-box;
  }
  & .bodyContent {
    width: 100%;
    min-height: 400px;
    margin-top: 30px;
    .navCalss {
      font-family: "PingFangSC-Semibold", "PingFang SC Semibold", "PingFang SC",
        sans-serif;
      font-weight: 650;
      font-size: 18px;
      margin-bottom: 10px;
    }
  }
  .pagination{
    float: right; margin-top: 20px; padding-right: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// announcement.vue?210f1666